/**
 * Time and date formatting shared by the week grid's blocks and the supervisor
 * review screen, so a block, its table row and a warning can never print the
 * same time or date two ways.
 */

/** Format a stored time ("09:00" or "09:00:00") like "9:00 AM". */
export function formatTime(time: string): string {
  const [hours, minutes] = time.split(':').map(Number);
  const h = hours ?? 0;
  const hour12 = h > 12 ? h - 12 : h === 0 ? 12 : h;
  const ampm = h >= 12 ? 'PM' : 'AM';
  return `${hour12}:${String(minutes ?? 0).padStart(2, '0')} ${ampm}`;
}

/** "Sun, Oct 4" from a YYYY-MM-DD work date. */
export function formatWorkDate(workDate: string): string {
  const date = new Date(`${workDate}T00:00:00`);
  return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}
